import React, { Component } from "react";
import { connect } from "react-redux";

import { Scroll } from "app/NativeComponents/common";

import { appRedirect } from "app/NativeActions";
import {
  RightPanelContainer,
  Wrapper,
  WebContainer,
  Container
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";

import Body from "./Body";

class MailerCalendar extends Component {
  componentDidMount() {}

  render() {
    if (
      this.props.location &&
      this.props.location.pathname == "/a/calendar" &&
      this.props.device != "mobile"
    ) {
      return (
        <Container includeInfoBanner={true}>
          <Header
            title="Calendar"
            leftButtonIcon={this.props.device == "desktop" ? "logo" : "menu"}
            leftButtonAction={
              this.props.device == "desktop"
                ? () => {}
                : () => this.props.toggleDrawer("open")
            }
          />
          <WebContainer>
            <Body />
          </WebContainer>
        </Container>
      );
    } else {
      return (
        <RightPanelContainer
          style={{
            backgroundColor: this.props.colors.background_color
          }}
        >
          <Scroll style={{ height: "100%" }}>
            <Header
              title="Calendar"
              leftButtonIcon="close"
              leftButtonAction={() =>
                this.props.appRedirect({
                  redirect: "goBack",
                  payload: { remove: "calendar" }
                })
              }
            />
            <Body />
          </Scroll>
        </RightPanelContainer>
      );
    }
  }
}

const mapStateToProps = ({ auth, settings, native }) => {
  const { token, user } = auth;
  const { colors } = settings;
  const { isMobile, device } = native;

  return {
    token,
    user,
    isMobile,
    colors,
    device
  };
};

export default connect(mapStateToProps, {
  appRedirect
})(MailerCalendar);
